<template>
  <!-- 我的收藏 -->
  <div class="purse-body">
    <!-- 标题 -->
    <p class="title-Individual-center">
      个人中心 <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">收藏</span>
    </p>
    <!-- 内容主体 -->
    <div class="Content-subject">
      <!-- 切换 -->
      <div class="Toggle">
        <p
          :class="Select == '1' ? 'Toggle-Select' : ''"
          @click="handelClick(1)"
        >
          职位收藏
        </p>
        <p
          :class="Select == '2' ? 'Toggle-Select' : ''"
          @click="handelClick(2)"
        >
          企业收藏
        </p>
      </div>
      <!-- 收藏内容 -->
      <div class="collected">
        <!-- 职位收藏 -->
        <JobColl
          :listArr="listArr"
          @handelCollect="handelCollect"
          @Refresh="getPositionCollectList()"
          v-if="Select == '1'"
        ></JobColl>
        <!-- 公司收藏 -->
        <CorCol
          :listArr1="listArr1"
          @handelCollectFirm="handelCollectFirm"
          v-else
        ></CorCol>
      </div>
      <!-- 底部分页 -->
      <div class="paging-box">
        <div class="paging">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
// 引入职位收藏页的接口
import {
  getPositionCollectList, // 职位收藏列表
  addPositionCollect, // 收藏职位
  cancelPositionCollect, // 取消职位收藏
  getCompanyCollectList, // 收藏公司列表
  addCompanyCollect, // 收藏公司
  cancelCompanyCollect, //取消公司收藏
} from "../../../../../assets/api/CentreCollect";
// 引入职位收藏组件
import JobColl from "./components/JobColl.vue";
// 引入公司收藏组件
import CorCol from "./components/CorCol.vue";
// 引入分页组件
import paging from "../../../../../components/paging.vue";
export default {
  data() {
    return {
      Select: "1", // 选中状态
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      },
      listArr1: [], // 企业收藏数据
      listArr: [], // 职位收藏数据
    };
  },
  components: {
    JobColl,
    paging,
    CorCol,
  },
  created() {
    this.getPositionCollectList();
  },
  methods: {
    // 取消公司收藏
    handelCollectFirm(val) {
      // 参数
      var data = {
        data: {
          userId: this.$store.getters.getUser.id,
          companyId: val.companyId,
        },
      };
      // 调用接口
      cancelCompanyCollect(data).then((res) => {
        if (res.code == 0) {
          // 成功
          this.$tool.PromptBox("success", "操作成功");
          this.getCompanyCollectList();
        } else {
          // 失败
          // this.$tool.PromptBox("error", res.msg);
        }
      });
    },
    // 取消职位收藏
    handelCollect(val) {
      // 参数
      var data = {
        data: {
          userId: this.$store.getters.getUser.id,
          positionId: val.positionId,
        },
      }; 
      // 调用接口
      cancelPositionCollect(data).then((res) => {
        if (res.code == 0) {
          // 成功
          this.$tool.PromptBox("success", "操作成功");
          this.getPositionCollectList();
        } else {
          // 失败
          // this.$tool.PromptBox("error", res.msg);
        }
      });
    },
    // 收藏职位列表
    async getPositionCollectList() {
      var data = {
        data: {
          userId: this.$store.getters.getUser.id,
        },
      };
      const res = await getPositionCollectList(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      );
      console.log(res, "res");
      this.pagingObj.totalDevice = res.data.total;
      this.listArr = res.data.list;
    },
    // 收藏公司列表
    async getCompanyCollectList() {
      var data = {
        data: {
          userId: this.$store.getters.getUser.id,
        },
      };
      const res = await getCompanyCollectList(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      );
      console.log(res, "res");
      this.pagingObj.totalDevice = res.data.total;
      this.listArr1 = res.data.list;
    },
    // 分页 函数
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      if (this.Select == "1") {
        // 职位收藏
        this.getPositionCollectList();
      } else {
        // 公司收藏
        this.getCompanyCollectList();
      }
    },
    // 切换 职位收藏/公司收藏
    handelClick(num) {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      };

      if (num == 1) {
        this.getPositionCollectList();
      } else {
        this.getCompanyCollectList();
      }
      this.Select = num;
    },
  },
};
</script>

<style scoped lang="less">
.purse-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
// 内容主体
.Content-subject {
  width: 100%;
  min-height: 540px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  margin-top: 13px;
  padding: 30px;
  // 切换
  .Toggle {
    width: 90%;
    height: 30px;
    margin-left: 13px;
    display: flex;
    p {
      height: 100%;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      text-align: center;
      font-weight: 400;
      box-sizing: border-box;
      cursor: pointer;
      // border-bottom: 2px solid #409eff ;
    }
    .Toggle-Select {
      color: #409eff ;
      border-bottom: 2px solid #409eff ;
    }
    p:nth-child(2) {
      margin-left: 40px;
    }
  }
  // 收藏的内容
  .collected {
    min-height: 410px;
    margin: 0 auto;
    margin-top: 15px;
  }
  // 分页
  .paging-box {
    width: 100%;
    height: 22px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    .paging {
      width: 90%;
      height: 100%;
      // margin-right: 45px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
